import { MypageNovelNovelIdChapterChapterIdPlateGetInputModel } from "../../../../api/v1/mypage/novel/[novel_id]/chapter/[chapter_id]/plate/GetInputModel"
import { getMypageNovelNovelIdChapterChapterIdPlate } from "../../../../api/v1/mypage/novel/[novel_id]/chapter/[chapter_id]/plate/get"
import { PlateData } from "src/models/tieup/novel/PlateData"

export const fetchChapterPlates = (params: {
  novelId: number
  chapterId: number
  offset?: number
  limit?: number
}): Promise<PlateData[]> => {
  return getMypageNovelNovelIdChapterChapterIdPlate(
    new MypageNovelNovelIdChapterChapterIdPlateGetInputModel(params),
  ).then((res) => {
    return res.results
  })
}
